// --------------------------------------------------------------------------
// parkingMap.js
// --------------------------------------------------------------------------
// Uses Google Maps API to create map with custom pins for parking locations
// --------------------------------------------------------------------------

EC.parkingMap = function () {

    'use strict';

    let map;
    let hcc;
    let infoWindows;

    function init () {

        hcc = {
            label: 'Harrogate Convention Centre',
            position: new google.maps.LatLng(53.996879, -1.541203),
            address: 'King\'s Road, HG1 5LA',
            directions: `https://www.google.co.uk/maps/dir//Harrogate+International+Centre,+King's+Road,+Harrogate/@53.994462,-1.5437363,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x487953e4318c670b:0x916c49bfe1e0009f!2m2!1d-1.541203!2d53.996879`
        }

        const carParks = [
            {
                label: 'Jubilee Car Park',
                position: new google.maps.LatLng(53.994532, -1.542537),
                address: 'Union Street, HG1 1DJ',
                directions: `https://www.google.co.uk/maps/dir//Jubilee+Car+Park,+Harrogate/@53.9943096,-1.5479031,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x487953e6a1f48d09:0x980bddf150bfd692!2m2!1d-1.5425374!2d53.9945318`
            },
            {
                label: 'Victoria Car Park',
                position: new google.maps.LatLng(53.993908, -1.537166),
                address: 'East Parade, HG1 5LQ',
                directions: `https://www.google.co.uk/maps/dir//Victoria+Car+Park,+Harrogate/@53.9932821,-1.5410728,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x487953e74fc6ceab:0x66737d6986248ea0!2m2!1d-1.5371663!2d53.9939079`
            },
            {
                label: 'ODEON Car Park',
                position: new google.maps.LatLng(53.992443, -1.5356332),
                address: 'Station Avenue, HG1 5LT',
                directions: `https://www.google.co.uk/maps/dir//ODEON+Harrogate,+East+Parade,+Harrogate/@53.9894962,-1.5401839,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x487953de1d1f9ee5:0xe3bb635ad6f92018!2m2!1d-1.5356333!2d53.9924433`
            },
            {
                label: 'West Park Multi-Storey Car Park',
                position: new google.maps.LatLng(53.98893, -1.539546),
                address: 'Tower Street, HG1 1HS',
                directions: `https://www.google.co.uk/maps/dir//West+Park+Multi-Storey+Car+Park,+Tower+St,+Harrogate+HG1+1HS/@53.9899065,-1.5386636,16.06z/data=!4m15!1m6!3m5!1s0x487953e1cb943c93:0xefab7322aea4ca61!2sWest+Park+Multi-Storey+Car+Park!8m2!3d53.9889303!4d-1.5395457!4m7!1m0!1m5!1m1!1s0x487953e1cb943c93:0xefab7322aea4ca61!2m2!1d-1.5395457!2d53.9889303`
            }, 
            {
                label: 'Harrogate Convention Centre Car Park',
                position: new google.maps.LatLng(53.997157, -1.541840),
                address: 'Springfield Avenue, HG1 2HR',
                directions: `https://www.google.com/maps/dir//53.9971667,-1.5418333/@53.9971667,-1.5429276,18z/data=!4m2!4m1!3e0`
            }
        ];

        infoWindows = [];

        initMap();
        addHccMarker();
        carParks.map(addParkingMarker);

    }

    function initMap () {
        map = new google.maps.Map(document.getElementById('js-parking-map'), {
            center: new google.maps.LatLng(53.992987, -1.539931),
            zoom: 15,
            scrollwheel: false,
            styles: [
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#C6E2FF"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#C5E3BF"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#D1D1B8"
                        }
                    ]
                }
            ]
        });
    }

    function addHccMarker (){
        var hccPin = new google.maps.Marker({
            map: map,
            position: hcc.position
        });

        createInfoWindow(hcc, hccPin);
    }

    function addParkingMarker (carPark) {
        var pin = new google.maps.Marker({
            map: map,
            position: carPark.position,
            optimized: false,
            icon: {
                url: '/resources/images/interface/parking-pin.svg',
                scaledSize: new google.maps.Size(35, 50)
            } 
        });

        createInfoWindow(carPark, pin);
    }

    function createInfoWindow (info, pin) {
        var infoWindow = new google.maps.InfoWindow({
            content: createWindowMarkup(info)
        });

        infoWindows.push(infoWindow);

        pin.addListener('click', function(){
            infoWindows.map(window => window.close());
            infoWindow.open(map, pin)
        });
    } 

    function createWindowMarkup (marker){
        return `<h4 class="b-parking-map__pin-heading">${marker.label}</h4>
                <p class="b-parking-map__pin-address">${marker.address}</p>
                <a href="${marker.directions}" target="_blank" class="b-parking-map__directions">Get directions</a>`
    }

    return {
        init: init
    };

}();